import React from 'react';
import type { UserProfileBadge } from '../types';
import { getUserProfileBadgeTitle } from '../utils/userProfileBadges';
import ShieldCheckIcon from './icons/ShieldCheckIcon';
import ChefHatIcon from './icons/ChefHatIcon';
import LeafIcon from './icons/LeafIcon';

interface UserProfileBadgesProps {
    badges: UserProfileBadge[];
    className?: string;
}

const BADGE_ICON_CLASS = 'w-5 h-5 shrink-0';

function renderBadgeIcon(badge: UserProfileBadge): React.ReactNode {
    switch (badge) {
        case 'ADMIN':
            return <ShieldCheckIcon className={`${BADGE_ICON_CLASS} text-indigo-500 dark:text-indigo-400`} aria-hidden="true" />;
        case 'CHEF':
            return <ChefHatIcon className={`${BADGE_ICON_CLASS} text-amber-500 dark:text-amber-400`} aria-hidden="true" />;
        case 'NUTRITIONIST':
            return <LeafIcon className={`${BADGE_ICON_CLASS} text-emerald-500 dark:text-emerald-400`} aria-hidden="true" />;
        default:
            return null;
    }
}

const UserProfileBadges: React.FC<UserProfileBadgesProps> = ({ badges, className = '' }) => {
    if (badges.length === 0) return null;

    return (
        <span className={`inline-flex flex-row items-center gap-1 shrink-0 ${className}`}>
            {badges.map((badge) => (
                <span
                    key={badge}
                    title={getUserProfileBadgeTitle(badge)}
                    className="inline-flex items-center justify-center"
                >
                    {renderBadgeIcon(badge)}
                </span>
            ))}
        </span>
    );
};

export default UserProfileBadges;
